import { Link, useSearchParams, useLocation } from 'react-router-dom';
import { cn } from '@/lib/utils';

export const categories = [
  { id: 'todos', label: 'Todos' },
  { id: 'UI', label: 'Design de UI' },
  { id: 'UX', label: 'Design de UX' },
  { id: 'Web Design', label: 'Design Web' },
  { id: 'App Design', label: 'Design de Aplicativos' },
  { id: 'Graphic Design', label: 'Design Gráfico' },
  { id: 'Logo Design', label: 'Design de Logotipos' },
  { id: 'Illustration', label: 'Ilustração' },
  { id: 'Typography', label: 'Tipografia' },
  { id: 'Animation', label: 'Animação' },
  { id: 'Other', label: 'Outros' }
];

export function CategoryFilter() {
  const [searchParams, setSearchParams] = useSearchParams();
  const location = useLocation();
  const currentCategory = searchParams.get('category') || 'todos';

  const createQueryString = (category: string) => {
    if (category === 'todos') {
      setSearchParams(params => {
        params.delete('category');
        return params;
      });
    } else {
      setSearchParams(params => {
        params.set('category', category);
        return params;
      });
    }
  };

  return (
    <div className="flex items-center gap-2 overflow-x-auto pb-4 scrollbar-thin scrollbar-thumb-gray-300 dark:scrollbar-thumb-gray-600">
      {categories.map((category) => (
        <Link
          key={category.id}
          to={`${location.pathname}`}
          onClick={(e) => {
            e.preventDefault();
            createQueryString(category.id);
          }}
          className={cn(
            'px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-colors',
            currentCategory === category.id
              ? 'bg-primary text-primary-foreground'
              : 'bg-gray-100 dark:bg-gray-800 hover:bg-gray-200 dark:hover:bg-gray-700'
          )}
        >
          {category.label}
        </Link>
      ))}
    </div>
  );
}